module.exports = __webpack_public_path__ + "img/16.176c0c50.png";